import { render, staticRenderFns } from "./UserQuestionAnswer.vue?vue&type=template&id=cd80b76c&"
import script from "./UserQuestionAnswer.vue?vue&type=script&lang=js&"
export * from "./UserQuestionAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports